import {useTranslation} from 'react-i18next'

export const RowHead = () => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>User</th>
      <th>Agent</th>
      <th>IP Address</th>
      <th>Path</th>
      <th>{t('Method')}</th>
      <th>{t('Request')}</th>
      <th>{t('error code')}</th>
      <th>{t('Message')}</th>
      <th>{t('Response')}</th>
      <th>Status</th>
      <th>{t('Created At')}</th>
    </tr>
  )
}
